import { render, staticRenderFns } from "./BAOrgLandingPage.vue?vue&type=template&id=652114e7&"
import script from "./BAOrgLandingPage.vue?vue&type=script&lang=ts&"
export * from "./BAOrgLandingPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports